import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import EN from "./locales/en/en.json";
import RU from "./locales/ru/ru.json";
import UZ from "./locales/uz/uz.json";
import AR from "./locales/ar/ar.json";
import AZ from "./locales/az/az.json";
import ES from "./locales/es/es.json";
import PT from "./locales/pt/pt.json";
import { getLang } from "./utils/utils";

// the translations
const resources = {
  en: { translation: EN },
  ru: { translation: RU },
  uz: { translation: UZ },
  ar: { translation: AR },
  az: { translation: AZ },
  es: { translation: ES },
  pt: { translation: PT }
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: getLang(),
  // debug: false,
  // keySeparator: false,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
